import PropTypes from 'prop-types';

import { ENGLISH, FRENCH, GERMAN, SPANISH } from '../utils/constants/language_region_codes';

export default PropTypes.oneOf([GERMAN, FRENCH, SPANISH, ENGLISH]);
